var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogle24(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "fill",
    d: "M16.1 7.47c-1.05-.99-2.4-1.5-3.9-1.5A6.07 6.07 0 0 0 6.17 12a6.07 6.07 0 0 0 6.03 6.02c1.38 0 2.55-.35 3.46-.95a4.6 4.6 0 0 0 2.04-3.02h-5.5v-3.87h9.61c.13.66.19 1.34.19 2.05 0 3.04-1.11 5.6-3.04 7.35A9.86 9.86 0 0 1 12.2 22c-3.98 0-7.44-2.24-9.11-5.5a9.83 9.83 0 0 1 0-9A10.22 10.22 0 0 1 12.2 2c2.75 0 5.06 1 6.83 2.6L16.1 7.47Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle24);
export default __webpack_public_path__ + "static/media/google_24.4e865bf75cb503ac895e714ae371c970.svg";
export { ForwardRef as ReactComponent };